import { NgModule } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { NgSelectModule } from "@ng-select/ng-select"

import { SharedComponentsModule } from "../shared-components/shared-components.module"
import { UserProfileRoutingModule } from "./user-profile-routing.module"
import { UserProfileComponent } from "./user-profile.component"
import { SchoolSelectorComponent } from "./school-selector/school-selector.component"
import { RoleSelectorComponent } from "./role-selector/role-selector.component"
import { UserProfileService } from "../services/user-profile.service"

@NgModule({
    declarations: [
        UserProfileComponent,
        SchoolSelectorComponent,
        RoleSelectorComponent,
    ],
    imports: [
        FormsModule,
        NgSelectModule,
        SharedComponentsModule,
        UserProfileRoutingModule,
    ],
    providers: [UserProfileService],
})
export class UserProfileModule {}
